import './ShippingDetailsPurchaseLoader.css';

const ShippingDetailsPurchaseLoader = ({ className = '' }) => {
  return (
    <div className={`shipping-details-purchase-loader ${className}`}></div>
  );
};

export default ShippingDetailsPurchaseLoader;
